import React, { useEffect, useState } from "react";
import { notification } from 'antd';
import { DescriptionText, FlexContainer, H1Text, H2Text, Hr, LeftBackButtonText, Spinner } from "../../../design";
import TransactionModal from "../../../components/modal/transaction";
import SuccessModal from "../../../components/modal/success";
import { findDonationPageLinkById,
  donationPageChargeById,
  BASE_URLS,
  getCheckoutReconnection,
  getQrPaymentReconnection,
  donationPageSplitUp,
  getHealthCheck,
  getSecretValuesById,
  getServerEncription,
  generateClientKeyPair,
  encryptData,
} from "../../../api";
import { MESSAGES, SWIREPAY_URL, TabNames, NETBANKING_LIST, QR_STATUSES, TANGEDCO_PG, SESSION_TIME, LPG_CUSTOMER } from "../../../appconstants";
import { AmountDivideByHundred } from "../../../helper";
import BaseSplitPage from "../../../components/splitpage";
import getRedirectionUrl from "../../../utils/getRedirectionUrl";
import currencyFormatter from "../../../utils/currencyformatter";
import CardPayment from "../../../components/cardpayment/CardPayment";
import Support from "../../../components/support";
import SmallScreenHeader from "../../../components/smallscreen/header";
// import DataAlertModal from "../components/DataAlert";
import getMenuTabs from "../../../utils/getMenuTabs";
import getUniquePaymentTypes from "../../../utils/getUniquePaymentTypes";
import UpiPayment from "../../../components/upipayment/UpiPayment";
import AchPayment from "../../../components/achPaymentWithPlaid";
import InstantPayment from "../../../components/instantpayment/InstantPayment";
import BankPayment from "../../../components/bankpayment/BankPayment";
import NetBanking from "../../../components/netbanking/NetBanking";
import ApplePay from "../../../components/applePay/ApplePay";
import GooglePay from "../../../components/googlePay/GooglePay";
import PaymentExpandableRows from "../../../components/paymentExpandableRows";
import UPIIMAGE from "../../../assets/imgs/upiNotification.svg";
import alert from "../../../components/modal/alert";
import RecaptchaModal from "../../../components/recaptcha";
import Apple from '../../apple';
import {getCountryCallingCode} from "libphonenumber-js";
import { useDispatch, useSelector } from "react-redux";
import { setUpdateStatus } from "../../../redux/customerDetailsInfo";

type Props = {
  history: {
    push: Function,
  },
}

const DonationPagePay = (props: Props) => {

  const { match: { params: { id } }, location: { pathname, search } } = props;
  const [isTransactionModalOpen, setTransactionModalOpen] = useState(false);
  const [isTransactionSuccessModalOpen, setTransactionSuccessModalOpen] = useState(false);
  const [isDataAlertModalOpen, setDataAlertModalOpen] = useState(false);
  const [paymentPageMeta, setPaymentPageMeta] = useState(null);
  const [paymentPageEntries, setPaymentPageEntries] = useState(null);
  const [errorMessage, setErrorMessage] = useState();
  const [isShowSpinner, setShowSpinner] = useState(false);
  const [backButtonUrl, setBackButtonUrl] = useState(SWIREPAY_URL);
  const [submitBtnText, setSubmitBtnText] = useState(null);
  const [submitBtnTextAch, setSubmitBtnTextAch] = useState(null);
  const [amount, setAmount] = useState(0);
  const [currency, setCurrency] = useState(null);
  const [supportedPaymentTypes, setSupportedPaymentTypes] = useState(null);
  const [paymentTypeOrder, setPaymentTypeOrder] = useState(null);
  const [selectedTab, setSelectedTab] = useState(parseInt(localStorage.getItem(`${id}-tap-index`) || 0));
  const [tabName, setTabName] = useState('');
  const [banksList, setBanksList] = useState(null);
  const [isTest, setIsTest] = useState(null);
  const [bankTypes, supportedBankTypes] = useState([null]);
  const [account, setAccount] = useState(null);
  const [processStatus, setProcessStatus] = useState(false);
  const tipValue = localStorage.getItem('tipValue');
  const tip = tipValue ? Number(AmountDivideByHundred(tipValue)) : null;
  const [serviceFee, setServiceFee] = useState(false);
  const [serviceFeeRate, setServiceFeeRate] = useState(false);
  const [serviceFeeVal, setServiceFeeVal] = useState(null);
  const [serviceFeeRateVal, setServiceFeeRateVal] = useState(null);
  const [finalAmount, SetFinalAmount] = useState(null);
  const [taxValue, setTaxValue] = useState(null);
  const [taxPercentage, setTaxPercentage] = useState(null);
  const [net, setNet] = useState(null);
  const [feeService, setFeeService] = useState(null);
  const [finalTax, setFinalTax] = useState(null);
  const [totalPayable, setTotalPayable] = useState(null);
  const [totalPayableAch, setTotalPayableAch] = useState(null);
  const [caluclation, setCaluclation] = useState(null);
  const [discount, setDiscount] = useState(null);
  const [loading, setLoading] = useState(false);
  const [finalTip, setFinalTip] = useState(null);
  const [subTotal, setSubTotal] = useState(null);
  const [applePayment, setApplePayment] = useState(false);
  const [ipAddress, setIpAddress] = useState('');
  const [upiDownTime, setUpiDownTime] = useState(false);
  const [isApplePay, setIsApplePay] = useState(false);
  const [gpaySecretValues, setGpaySecretValues] = useState(null);
  const [gpayError, setGpayError] = useState(null);
  const [swirepayUS, setSwirepayUS] = useState(false);
  const [googlePayUs, setGooglePayUs] = useState(false);
  const [googlePayUsRecurring, setGooglePayUsRecurring] = useState(false);
  const entries = JSON.parse(localStorage.getItem('donationDtails'));
  const [surcharge, setSurcharge] = useState(null);
  const [updatedCardNum, setUpdatedCardNum] = useState('');
  const [optionalCheck, setOptionalCheck] = useState(true);
  const [plaidPublicToken, setPlaidPublicToken] = useState(() => localStorage.getItem(`plaidPublicToken-${id}`) || undefined);
  const [customerDetails, setCustomerDetails] = useState(null);
  const [recaptchaModalVisible, setRecaptchaModalVisible] = useState(false);
  const [savedPaymentDetails, setSavedPaymentDetails] = useState(null);
  const [recaptchaPaymentType, setRecaptchaPaymentType] = useState(null);
  const [paymentLinkUpiGlobalRecaptcha, setPaymentLinkUpiGlobalRecaptcha] = useState(null);
  const [paymentLinkInstantPaymentGlobalRecaptcha, setPaymentLinkInstantPaymentGlobalRecaptcha] = useState(null);
  const updateCustomerRedux = useSelector((state) => state.customerDetailsInfo);
  const dispatch = useDispatch();
  const paramsId = id;

  const accountGid = [
    'account-cdfe7eecff324778a88a2727177a1c8f'
  ];

  const hostName = (window && window.location && window.location.host);
  const getData = async () => {
    const response = await fetch('https://api.ipify.org/?format=json');
    const data = await response.json();
    setIpAddress(data.ip);
  }

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (search) {
      getPaymentPageLinkDataWithSearchValue();
    } else {
      getPaymentLinkDataWithoutSearchValue();
    }
    setBackButtonUrl(`/donation-page-link/${id}`);
  }, [id, search]);

  useEffect(() => {
    document.body.style.backgroundImage = ''
  }, []);

  useState(() => {
    if (window.ApplePaySession) {
      setIsApplePay(true);
    }
  }, []);

  useEffect(() => {
    if (currency && currency.name !== 'INR') { setSelectedTab(0) }
  }, [selectedTab,]);

  const getCurrentTab = (tabName) => {
    getSplitUp(paymentPageMeta?.gid, tabName, '');
  };

    useEffect(() => {
      if(updateCustomerRedux?.updateStatus && updateCustomerRedux?.customerDetails){
          if (updateCustomerRedux?.customerDetails?.name  && updateCustomerRedux?.customerDetails?.name !== '') {
              setCustomerDetails((prev) => ({...prev, name: updateCustomerRedux.customerDetails.name }));
          };
          if (updateCustomerRedux?.customerDetails?.email  && updateCustomerRedux?.customerDetails?.email !== '') {
              setCustomerDetails((prev) => ({...prev, email: updateCustomerRedux.customerDetails.email }));
          };
          if (updateCustomerRedux?.customerDetails?.phoneNumber && updateCustomerRedux?.customerDetails?.phoneNumber !== 'undefined'
              && updateCustomerRedux?.customerDetails?.phoneNumber !== '+1'
          ) {
              setCustomerDetails((prev) => ({...prev, phoneNumber: updateCustomerRedux.customerDetails.phoneNumber }));
          };
          dispatch(setUpdateStatus(false));
      };
  }, [updateCustomerRedux]);

  useEffect(() => {
    let totalAmount = 0;
    if (entries?.amount) {
      totalAmount = entries.amount;
    }
    if (account) {
      const feeRateService = (AmountDivideByHundred(totalAmount) * AmountDivideByHundred(serviceFeeRate)) / 100;
      const tipValue = tip ? ((AmountDivideByHundred(totalAmount) * (tip / 100))) : 0;
      const taxValue = taxPercentage ? ((AmountDivideByHundred(totalAmount) * AmountDivideByHundred(taxPercentage)) / 100) : 0;
      const taxVal = feeRateService + tipValue + (serviceFee / 100) + taxValue;
      const localCurrency = account.currency;
      setCurrency(localCurrency);
      setTaxValue(taxVal);
      setSubmitBtnText(`PAY ${account?.currency?.prefix} ${totalPayable ? AmountDivideByHundred(totalPayable) : '0.00'}`);
      setSubmitBtnTextAch(`PAY ${account?.currency?.prefix} ${(totalPayable - feeService) ? AmountDivideByHundred((totalPayable - feeService)) : '0.00'}`);
      setTotalPayableAch((totalPayable - feeService));
      setServiceFeeRateVal((AmountDivideByHundred(totalAmount) * AmountDivideByHundred(serviceFeeRate)) / 100);
      setServiceFeeVal(AmountDivideByHundred(serviceFee));
      setAmount(totalPayable / 100);
      SetFinalAmount(`${account?.currency?.prefix} ${totalPayable || 0}`)
    }    
  }, [id, caluclation, account]);

  const getGooglePayMerchantValues = async (accountGid) => {
    try {
        const values = await getSecretValuesById(accountGid, null);
        setGpaySecretValues(values);
    } catch (error) {
        setGpayError('Missing merchant details. Please contact support')
    }
};

  const paymentPageChargeCard = async (data) => {
    const { customer, paymentMethod, notify } = data;
    const userAgent = {
      acceptHeaders: "Accept: text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8", 
      ip: ipAddress,
      language: window.navigator.language, 
      colorDepth: window.screen.colorDepth,
      screenHeight: window.screen.height, 
      screenWidth: window.screen.width,
      timeZone: new Date().getTimezoneOffset(), 
      browserUserAgent: window.navigator.userAgent
     };
     paymentMethod.userAgent = userAgent;
     const payload = {
      donationPageMetaGid: paymentPageMeta?.gid,
      customerDetails: customer,
      paymentMethodDetails: paymentMethod,
      amount: subTotal,
      interval: entries?.interval,
      notes: entries?.notes,
      shareEmail: entries?.shareEmail,
      sharePhoneNumber: entries?.sharePhoneNumber,
      shareName: entries?.shareName,
      shareAddress: entries?.shareAddress,
      shouldWhatsAppNotify: notify,
     }
    await chargeById(payload)
  };

  const paymentPageChargeByUPI = async (data) => {
    const { customer, paymentMethod, notify } = data;
    await chargeById({
      donationPageMetaGid: paymentPageMeta.gid,
      shouldWhatsAppNotify: notify,
      customerDetails: customer, paymentMethodDetails: paymentMethod,
      interval: entries?.interval,
      notes: entries?.notes,
      shareEmail: entries?.shareEmail,
      sharePhoneNumber: entries?.sharePhoneNumber,
      shareName: entries?.shareName,
      shareAddress: entries?.shareAddress, paymentMethodType: ['UPI']
    });
  };


  const chargeByApple = async (deviceData, amount, customerName, customerEmail,
    customerPhone, countryCode, stateCode, street, postalCode, city,
    cardNetwork, cardType, cardLast4) => {
    const paymentMethod = {
      applePayUS: {
        deviceData: deviceData,
        cardBrand: cardNetwork,
        cardFundingType: cardType,
        applePayDynamicLast4: cardLast4,
        donationPageMetaGid: paymentPageMeta.gid,
        paymentMethodType: [''],
        cardLast4: cardLast4
      },
      type: "WALLET",
      subType: "APPLE_PAY_US",
      postalCode: postalCode,
      paymentMethodBillingAddress: {
        city: city,
        countryCode: countryCode,
        state: stateCode,
        street: street
      }
    }
    let customer = {
      email: customerEmail,
      name: customerName,
      phoneNumber: customerPhone
    }
    await chargeById({
      paymentMethod: paymentMethod,
      interval: entries?.interval,
      notes: entries?.notes,
      shareEmail: entries?.shareEmail,
      sharePhoneNumber: entries?.sharePhoneNumber,
      shareName: entries?.shareName,
      shareAddress: entries?.shareAddress,
      customerGid: getCustomerGidFromPayment(paymentPageMeta),
      customerDetails: customer,
      paymentMethodDetails: paymentMethod,
      amount: totalPayable,
      donationPageMetaGid: paymentPageMeta.gid,
      paymentMethodType: [
        "WALLET"
      ],
    });

  }

const getCustomerGidFromPayment = () => {
  return paymentPageMeta  && paymentPageMeta.gid;
};
  const paymentPageChargeByACH = async (data) => {
    const { customer, paymentMethod, notify } = data;
    await chargeById({
      donationPageMetaGid: paymentPageMeta.gid,
      shouldWhatsAppNotify: notify,
      customerDetails: customer, paymentMethodDetails: paymentMethod,
      interval: entries?.interval,
      notes: entries?.notes,
      shareEmail: entries?.shareEmail,
      sharePhoneNumber: entries?.sharePhoneNumber,
      shareName: entries?.shareName,
      shareAddress: entries?.shareAddress, paymentMethodType: ['ACH_LEGACY'],
      skipServiceFee: true,
      amount: totalPayable,
    });
  };

  const chargeByInstantPay = async (data) => {
    const { customer, walletAlias, notify } = data;
    const paymentMethod = {
      type: "INSTANT_PAYMENT",
      instantPayment: {
        alias: walletAlias,
        type: "ALIAS",
      },
    };
    await chargeById({
      paymentMethodDetails: paymentMethod,
      donationPageMetaGid: paymentPageMeta.gid,
      shouldWhatsAppNotify: notify,
      interval: entries?.interval,
      notes: entries?.notes,
      shareEmail: entries?.shareEmail,
      sharePhoneNumber: entries?.sharePhoneNumber,
      shareName: entries?.shareName,
      shareAddress: entries?.shareAddress,
      customerDetails: customer,
      paymentMethodType: ['INSTANT_PAYMENT']
    });
  };

  const chargeBySwirepayUS = async (data) => {
    const { walletAlias, notify } = data;
    const paymentMethod = {
      type: "WALLET",
      subType: "SWIREPAY_US",
      swirepayUS: {
        alias: walletAlias,
        type: "ALIAS",
      },
    };
    await chargeById({
      paymentMethodDetails: paymentMethod,
      donationPageMetaGid: paymentPageMeta.gid,
      shouldWhatsAppNotify: notify,
      interval: entries?.interval,
      notes: entries?.notes,
      shareEmail: entries?.shareEmail,
      sharePhoneNumber: entries?.sharePhoneNumber,
      shareName: entries?.shareName,
      shareAddress: entries?.shareAddress,
      amount: totalPayable,
      paymentMethodType: ['WALLET']
    });
  };

  const paymentPageChargeByBANK = async (data) => {
    const { customer, customerGid, fundingSourceId } = data;
    const paymentMethod = {
      bank: {
        referenceId: fundingSourceId,
      },
      customerGid,
      type: "ACH"
    }
    await chargeById({
      donationPageMetaGid: paymentPageMeta.gid,
      paymentMethodDetails: paymentMethod,
      customerDetails: customer,
      interval: entries?.interval,
      notes: entries?.notes,
      shareEmail: entries?.shareEmail,
      sharePhoneNumber: entries?.sharePhoneNumber,
      shareName: entries?.shareName,
      shareAddress: entries?.shareAddress, paymentMethodType: ['ACH']
    });
  };

  const chargeByApplePay = async (stripePaymentMethod) => {
    // const meta = stripePaymentMethod;
    const paymentMethod = {
      applePayUS: {
            stripePaymentMethodId: stripePaymentMethod.id,
            cardBrand: stripePaymentMethod.card.brand,
            cardExpMonth: stripePaymentMethod.card.exp_month,
            cardExpYear: stripePaymentMethod.card.exp_year,
            cardFundingType: stripePaymentMethod.card.funding,
            applePayDynamicLast4: stripePaymentMethod.card.wallet.dynamic_last4,
            cardLast4: stripePaymentMethod.card.last4,
            billingAddress: {
              street: stripePaymentMethod.billing_details.address.line1,
              city: stripePaymentMethod.billing_details.address.city,
              state: stripePaymentMethod.billing_details.address.state,
              postalCode: stripePaymentMethod.billing_details.address.postal_code,
              countryCode: stripePaymentMethod.billing_details.address.country
            },
            name: stripePaymentMethod.billing_details.name,
            email: stripePaymentMethod.billing_details.email,
            phone: stripePaymentMethod.billing_details.phone
          },
          customerGid: account.gid,
          type: "WALLET",
          subType: "APPLE_PAY_US",
          amount: totalPayable,
          rawData: {
            stripePaymentMethodId: stripePaymentMethod.id,
            cardBrand: stripePaymentMethod.card.brand,
            cardExpMonth: stripePaymentMethod.card.exp_month,
            cardExpYear: stripePaymentMethod.card.exp_year,
            cardFundingType: stripePaymentMethod.card.funding,
            applePayDynamicLast4: stripePaymentMethod.card.wallet.dynamic_last4,
            cardLast4: stripePaymentMethod.card.last4,
            billingAddress: {
              street: stripePaymentMethod.billing_details.address.line1,
              city: stripePaymentMethod.billing_details.address.city,
              state: stripePaymentMethod.billing_details.address.state,
              postalCode: stripePaymentMethod.billing_details.address.postal_code,
              countryCode: stripePaymentMethod.billing_details.address.country
            },
            name: stripePaymentMethod.name,
            email: stripePaymentMethod.email,
            phone: stripePaymentMethod.phone
          }
        };
    await chargeById({ paymentMethod: paymentMethod, customerGid: account.gid });
};

const chargeByGooglePay = async (data) => {
  const phoneNumber = data?.paymentMethodData?.info?.billingAddress?.phoneNumber.replace(/[\s\-]/g, '') || "";
  const formattedPhoneNumber = phoneNumber !== ""
      ? `+${getCountryCallingCode(data?.paymentMethodData?.info?.billingAddress?.countryCode)}${phoneNumber}`
      : "";

  let customerDetails = {
        email: data?.email || "",
        phoneNumber: formattedPhoneNumber,
        name: data?.shippingAddress?.name || "",
}
  const paymentMethod = {
      type: "WALLET",
      subType: "GOOGLE_PAY_US",
      googlePayUS: {
          apiVersionMinor: data.apiVersionMinor,
          apiVersion: data.apiVersion,
          paymentMethodDescription: data.paymentMethodData.description,
          paymentMethodTokenizationDataType: data.paymentMethodData.tokenizationData.type,
          paymentMethodTokenizationDataToken: data.paymentMethodData.tokenizationData.token,
          paymentMethodType: data.paymentMethodData.type,
          paymentMethodInfo: data.paymentMethodData.info
      },
  };
  await chargeById({ paymentMethodDetails: paymentMethod, customerDetails,interval: entries?.interval, amount:entries?.amount
  });
};

  const chargeByNetBanking = async (data) => {
    const { customer, gid, notify } = data;
    const paymentMethod = {
      type: "NET_BANKING",
      netbanking: {
        swirepayBankGid: gid,
      },
    };
    await chargeById({
      donationPageMetaGid: paymentPageMeta.gid,
      customerDetails: customer,
      shouldWhatsAppNotify: notify,
      paymentMethodDetails: paymentMethod,
      interval: entries?.interval,
      notes: entries?.notes,
      shareEmail: entries?.shareEmail,
      sharePhoneNumber: entries?.sharePhoneNumber,
      shareName: entries?.shareName,
      shareAddress: entries?.shareAddress,
      paymentMethodType: ['NET_BANKING'],
    });
  };

  const updateSurcharge = (val) => {
    getSplitUp(paymentPageMeta?.gid, localStorage.getItem(`${id}-tab-name`) ? localStorage.getItem(`${id}-tab-name`) : 0, updatedCardNum, val);
  }

  const getCardNum = (cardNum) => {
    setUpdatedCardNum(cardNum);
    getSplitUp(paymentPageMeta?.gid, localStorage.getItem(`${id}-tab-name`) ? localStorage.getItem(`${id}-tab-name`) : 0, cardNum);
  }

  const getSplitUp = async (metaGid, tabName, cardNum, val) => {
    const payload = {
      amount: entries?.amount,
      paymentType: (tabName !== 'CARD' && !cardNum) ? tabName : (cardNum ? 'CARD' : ''),
      cardNumber: tabName === 'CARD' ? cardNum : '',
      surchargeApplicable: (account?.surchargeType && account?.surchargeType !== 'NONE') ? true : false,
    }
    if (val === true ||  val === false) {
      setOptionalCheck(val)
      payload.surchargeApplicable = val;
    }
    try {
      const value = await donationPageSplitUp(metaGid, payload);
      setNet(value.net);
      setFeeService(value.serviceFee);
      setFinalTax(value.tax);
      setTotalPayable(value.totalPayable);
      setCaluclation(value);
      setFinalTip(value.tip);
      setDiscount(value.discountedAmount);
      setSubTotal(value.subTotal);
      setSurcharge(value.surcharge);
    } catch (reason) {
      error(reason);
    }
    setLoading(true);
  }
  

  const chargeById = async (data, recaptchaToken = null) => {
    data.surchargeApplicable = account?.surchargeType === 'OPTIONAL' ? optionalCheck : (account?.surchargeType !== 'NONE') ? true : false;
    setTransactionModalOpen(true);
    try {
      const values = await getServerEncription(recaptchaToken);
      if (values?.public_key) {
        const keys = generateClientKeyPair();
        if (keys?.privateKey) {
          const encriptedData = encryptData(JSON.stringify(data), values.public_key, keys.privateKey, values.key_id);
          const payload = {
            publicKey: keys?.publicKey,
            keyId: encriptedData?.keyId,
            iv: encriptedData?.iv,
            data: encriptedData?.encryptedData,
          }
          if (encriptedData?.keyId) {
            const value = await donationPageChargeById(id, payload);
            if (value) {
              let nextActionUrl, redirectUri, paymentStatus;

              if (value?.paymentSession) {
                ({ nextActionUrl, redirectUri, paymentStatus } = value.paymentSession);
              } else {
                ({ nextActionUrl, redirectUri, paymentStatus } = value);
              }
              if (paymentStatus && paymentStatus === 'PROCESSING') {
                setProcessStatus(true);
              }
              const timeOut = redirectUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
              if (nextActionUrl) {
                window.location = nextActionUrl;
                return;
              }
              if (redirectUri) {
                window.location = redirectUri;
                return;
              }
              setTransactionModalOpen(false);
              if (!redirectUri) {
                setTransactionSuccessModalOpen(true);
              }
              setTimeout(function () {
                window.location = `/donation-page-link/${id}` || SWIREPAY_URL;
              }, timeOut);
              sessionStorage.removeItem("stripeRes");
              if (id) { localStorage.removeItem('donationDtails'); localStorage.removeItem(`${id}-tap-index`); localStorage.removeItem(`${id}-tab-name`) }
            }
          }
        }
      }
    } catch (reason) {
      if (reason?.status === 429){
        setSavedPaymentDetails(data);
        setRecaptchaModalVisible(true);
        setTransactionModalOpen(false);
        return;
      }
      error(reason);
    }
  };

  const onGlobalCaptchaVerified = async (token) => {
    setRecaptchaModalVisible(false);
    switch (recaptchaPaymentType) {
      case TabNames.UPI:
        setPaymentLinkUpiGlobalRecaptcha(token);
        return;
      case TabNames.INSTANT_PAYMENT:
        setPaymentLinkInstantPaymentGlobalRecaptcha(token);
        return;
      default:
        await chargeById(savedPaymentDetails, token);
    }
    setRecaptchaPaymentType(null);
  }

  const getPaymentLinkDataWithoutSearchValue = async () => {
    await getDonationPageMetaById();
  };

  const getDonationPageMetaById = async () => {
    try {
      const value = await findDonationPageLinkById(id);
      if (value) {
        if (value.account.integratedMerchant && LPG_CUSTOMER.includes(atob(value.account.integratedMerchant))) {
        //   const val = await getHealthCheck();
        //   if (val && val.status !== 'ACTIVE') {
        //     setUpiDownTime(true);
        //     notification.open({
        //         message: '',
        //         description: <img src={UPIIMAGE} alt="" />,
        //       });
        // }
        }
        getSplitUp(value?.donationPageMeta?.gid, localStorage.getItem(`${id}-tab-name`) ? localStorage.getItem(`${id}-tab-name`) : 0, '');
        setPaymentPageMeta(value?.donationPageMeta);
        setAccount(value?.account);
       
        setServiceFee(value.donationPageMeta && value.donationPageMeta.serviceFee);
        setServiceFeeRate(value.donationPageMeta && value.donationPageMeta.serviceFeeRate);
        setTaxPercentage(value.donationPageMeta && value.donationPageMeta.taxPercentage);
        if (value && value.account && value.account.gid) {
          setApplePayment(value && value.account && value.account.supportedPaymentTypes && value.account.supportedPaymentTypes.includes('APPLE_PAY_US'));
          setSwirepayUS(value && value.account && value.account.supportedPaymentTypes.includes('SWIREPAY_US'));
          setGooglePayUs(value && value.account && value.account.supportedPaymentTypes.includes('GOOGLE_PAY_US'));
          setGooglePayUsRecurring(value && value.account && value.account.supportedRecurringPaymentTypes.includes('GOOGLE_PAY_US'));
          if ((value && value.account && value.account.supportedPaymentTypes && value.account.supportedPaymentTypes).includes('GOOGLE_PAY_US') || (value && value.account && value.account.supportedPaymentTypes && value.account.supportedPaymentTypes).includes('WALLET')) {
            getGooglePayMerchantValues(value && value.account && value.account.gid);
        }
        if ((value && value.account && value.account.supportedPaymentTypes && value.account.supportedPaymentTypes).includes('APPLE_PAY_US') || (value && value.account && value.account.supportedPaymentTypes && value.account.supportedPaymentTypes).includes('WALLET')) {
            getGooglePayMerchantValues(value && value.account && value.account.gid);
        }
          if (TANGEDCO_PG === value.account.gid) {
            if (value.account.paymentTypeOrder) {
              setPaymentTypeOrder([{ category: 'CARD' }]);
            } else setSupportedPaymentTypes(['CARD']);
          } else if (TANGEDCO_PG !== value.account.gid) {
            if (value.account.paymentTypeOrder) {
              const paymentMethod = getUniquePaymentTypes(value.account && value.account.supportedPaymentTypes);
              const paymentOrders = value && value.account && value.account.paymentTypeOrder;
              const filterPaymentOrder = paymentOrders.filter((order) => paymentMethod.includes(order.category));
              const wallet = paymentOrders.filter((item) => item.category === 'WALLET');         
              let newfilterPaymentOrder;
              if (value.account && paymentMethod.includes('WALLET')) {
                setPaymentTypeOrder(filterPaymentOrder);
              } if (value.account 
                && (value.account.supportedPaymentTypes.includes('GOOGLE_PAY_US') || value.account.supportedPaymentTypes.includes('SWIREPAY_US')) 
                && wallet && wallet.length > 0) {
                const googlePay = {
                  order: 4,
                  category: "WALLET",                  
                }
                filterPaymentOrder.push(googlePay);
                setPaymentTypeOrder(filterPaymentOrder);
                setPaymentTypeOrder(filterPaymentOrder);
              } else {
                newfilterPaymentOrder = filterPaymentOrder.filter(info => info.category !== 'WALLET');
                setPaymentTypeOrder(newfilterPaymentOrder);
              }
            } else {
              setSupportedPaymentTypes(value.account && value.account.supportedPaymentTypes);
            }
          }
        }
        if (value.account && value.account.portal) {
          const portal = value.account.portal.test;
          setIsTest(portal);
          supportedBankTypes(value.account.supportedPaymentTypes);
          if (portal) {
            const supportedBanks = NETBANKING_LIST.filter(data => (data.isTest === true));
            setBanksList(supportedBanks);
          } else {
            const supportedBanks = NETBANKING_LIST.filter(data => (data.isTest === false));
            setBanksList(supportedBanks);
          }
        }
      }
    } catch (e) {
      props.history.push(`${pathname}/error`);
    }
  };

  const getQrPaymentById = async (paymentSession, psClientSecret, redirectionUri) => {
    try {
      const value = await getQrPaymentReconnection(paymentSession, psClientSecret);
      if (value) {
        const { status, receiptNumber } = value;
        const timeOut = redirectionUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
        if (status === QR_STATUSES.SUCCEEDED) {
          if (!redirectionUri) {
            setTransactionSuccessModalOpen(true);
          }
          setTimeout(function () {
            const uri = getRedirectionUrl(hostName);
            const redirectUrl = redirectionUri ? redirectionUri : '';
            const urlPath = redirectUrl.includes("?");
            if (urlPath) {
              window.location = `${redirectUrl}&donation-page-link=${id}`;
            } else if (redirectUrl && !urlPath) {
              window.location = `${redirectUrl}?donation-page-link=${id}`;
            } else if (uri) {
              window.location = `${uri}receipts/${receiptNumber}`;
            }
          }, timeOut);
          if (id) { localStorage.removeItem(`${id}-tap-index`); localStorage.removeItem(`${id}-tab-name`); }
        }
      }
    } catch (reason) {
      error(reason);
    }
  };

  const getPaymentPageLinkDataWithSearchValue = async () => {
    const params = new URLSearchParams(search);
    if (!params.get('ps') || !params.get('secret')) {
      props.history.push(`${pathname}/error`);
      return;
    }
    setShowSpinner(true);
    try {
      const value = await findDonationPageLinkById(id, search);
      if (value) {
        const { redirectUri } = value;
        const timeOut = redirectUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
        if (!redirectUri) {
          setTransactionSuccessModalOpen(true);
        }
        setTimeout(function () {
          if (redirectUri) {
            window.location = redirectUri;
          } else props.history.push(`/donation-page-link/${id}`);
        }, timeOut);
        if (id) { localStorage.removeItem('donationDtails'); }
      }
    } catch (reason) {
      getPaymentLinkDataWithoutSearchValue();
      error(reason);
    } finally {
      setShowSpinner(false)
    }
  };

  const error = reason => {
    setErrorMessage(null);
    if (!reason) return;
    const { data: { message, messageCode }, status } = reason;
    if (messageCode === 5102) {
      props.history.push(`${pathname}/error`);
      return;
    }
    setErrorMessage(message);
    if (status === 500) {
      setErrorMessage(MESSAGES.PAYMENT_LINK.ERROR);
    }
    setTransactionModalOpen(false);
    const errorEl = document.getElementById("error");
    if (null !== errorEl) { errorEl.scrollIntoView(); }
  };

  const uniquePaymentTypes = paymentTypeOrder ? paymentTypeOrder.map((res) => res ? res.category : null) : supportedPaymentTypes ? getUniquePaymentTypes(supportedPaymentTypes) : '';
  if(uniquePaymentTypes.includes('WALLET')) {
    if (swirepayUS && entries?.interval === 'ONETIME') {
        uniquePaymentTypes.push('SWIREPAY_US');
    }
    if((!googlePayUs && entries?.interval === 'ONETIME') || (!googlePayUsRecurring && entries?.interval !== 'ONETIME')){
      const index = uniquePaymentTypes.indexOf('WALLET');
      if (index > -1) {
        uniquePaymentTypes.splice(index, 1);
      }
    }
}
  const tabPanels = uniquePaymentTypes ? uniquePaymentTypes.reduce(function (panel, name) {
    let children;
    let id;
    if (name === TabNames.ACH_LEGACY) {
      children = <AchPayment
        errorMsg={errorMessage}
        errorHeader={null}
        customerReadOnly={false}
        submit={paymentPageChargeByACH}
        customerEnabled={true}
        preFillCustomer={customerDetails}
        headerText={accountGid.includes(account?.gid) ? "Pay With BANK" : "Pay With ACH"}
        buttonText={submitBtnTextAch}
        customerValidation={true}
        showWhatsAppNotify={false}
        tip={finalTip}
        surcharge={surcharge}
        serviceFee={serviceFee}
        serviceFeeRate={serviceFeeRate}
        serviceFeeRateVal={serviceFeeRateVal}
        amount={net}
        serviceFeeVal={0}
        alpha2={currency && currency.countryAlpha2}
        prefix={currency && currency.prefix}
        tax={finalTax}
        totalPayable={totalPayableAch}
        discount={discount}
        subTotal={subTotal}
        isBillingAdressRequired={(account && account.collectBillingAddress)}
        plaidPublicToken={plaidPublicToken}
        setPlaidPublicToken={setPlaidPublicToken}
        accountGid={account?.gid}
        paymentLinkId={paramsId}
      />
      id = name;
    } else if (name === TabNames.CARD) {
      children = <CardPayment
        errorMsg={errorMessage}
        errorHeader={null}
        customerReadOnly={false}
        submit={paymentPageChargeCard}
        customerFields={{}}
        paymentPagePay={false}
        preFillCustomer={customerDetails}
        headerText={"Pay With Card"}
        buttonText={submitBtnText}
        isZipCodeRequired={(account && account.collectCustomerAddress)}
        isBillingAdressRequired={(account && account.collectBillingAddress)}
        showWhatsAppNotify={false}
        customerValidation={true}
        tip={finalTip}
        surcharge={surcharge}
        serviceFee={serviceFee}
        serviceFeeRate={serviceFeeRate}
        serviceFeeRateVal={serviceFeeRateVal}
        amount={net}
        serviceFeeVal={feeService}
        alpha2={currency && currency.countryAlpha2}
        prefix={currency && currency.prefix}
        tax={finalTax}
        totalPayable={totalPayable}
        discount={discount}
        subTotal={subTotal}
        validateAmount={totalPayable ? totalPayable / 100 : amount}
        payment={{amount: totalPayable && totalPayable, currency: currency && currency}}
        chargeByApplePay={chargeByApplePay}
        ApplePayment={applePayment}
        accountId={account && account.gid}
        getCardNum={getCardNum}
        surchargeType={account?.surchargeType}
        updateSurcharge={updateSurcharge}
        surchargeEnabled={paymentPageMeta?.surchargeEnabled}
      />
      id = name;
    } else if (name === TabNames.UPI) {
      children = <UpiPayment
        errorMsg={errorMessage}
        errorHeader={null}
        customerReadOnly={false}
        paymentPagePay={true}
        customerFields={{}}
        paymentPageMeta={paymentPageMeta}
        account={account}
        paymentPageEntries={paymentPageEntries}
        submit={paymentPageChargeByUPI}
        preFillCustomer={customerDetails}
        showWhatsAppNotify={false}
        headerText={"Pay With UPI"}
        hideQr={false}
        buttonText={submitBtnText}
        customerValidation={true}
        getPaymentById={getQrPaymentReconnection}
        upiUrl={`${BASE_URLS.PAYMENT_PAGE_LINK}/${id}`}
        tip={finalTip}
        surcharge={surcharge}
        serviceFee={serviceFee}
        serviceFeeRate={serviceFeeRate}
        serviceFeeRateVal={serviceFeeRateVal}
        amount={net}
        serviceFeeVal={feeService}
        alpha2={currency && currency.countryAlpha2}
        prefix={currency && currency.prefix}
        tax={finalTax}
        totalPayable={totalPayable}
        discount={discount}
        subTotal={subTotal}
        supportedPaymentTypes={account && account.supportedPaymentTypes}
        setRecaptchaModalVisible={setRecaptchaModalVisible}
        setSavedPaymentDetails={setSavedPaymentDetails}
        savedPaymentDetails={savedPaymentDetails}
        globalRecaptchaToken={paymentLinkUpiGlobalRecaptcha}
        setGlobalRecaptchaToken={setPaymentLinkUpiGlobalRecaptcha}
        setRecaptchaPaymentType={setRecaptchaPaymentType}
      />
      id = name;
    } else if (name === TabNames.ACH) {
      children = <BankPayment
        errorMsg={errorMessage}
        errorHeader={null}
        customerDisabled={false}
        submit={paymentPageChargeByBANK}
        headerText={"Pay With Bank Transfer"}
        buttonText={submitBtnText}
        paymentLinkId={id}
        showWhatsAppNotify={false}
        iavUrl={`${BASE_URLS.PAYMENT_PAGE_LINK}/${id}`}
        customerValidation={true}
        requiredPhone={true}
        paymentPageGId={account && account.gid}
        publicKey={account && account.usPublicKey}
        tip={finalTip}
        surcharge={surcharge}
        serviceFee={serviceFee}
        serviceFeeRate={serviceFeeRate}
        serviceFeeRateVal={serviceFeeRateVal}
        amount={net}
        serviceFeeVal={feeService}
        alpha2={currency && currency.countryAlpha2}
        prefix={currency && currency.prefix}
        tax={finalTax}
        totalPayable={totalPayable}
        discount={discount}
        subTotal={subTotal}
      />
      id = name;
    } else if (name === TabNames.NET_BANKING) {
      children = <NetBanking
        errorMsg={errorMessage}
        errorHeader={null}
        customerReadOnly={false}
        customerFields={{}}
        submit={chargeByNetBanking}
        headerText={"PAY WITH NET BANKING"}
        cancelButtonText={"Decline"}
        buttonText={submitBtnText}
        customerValidation={true}
        banksList={banksList}
        bankTypes={bankTypes}
        isTest={isTest || true}
        showWhatsAppNotify={false}
        paymentPage={true}
        tip={finalTip}
        surcharge={surcharge}
        serviceFee={serviceFee}
        serviceFeeRate={serviceFeeRate}
        serviceFeeRateVal={serviceFeeRateVal}
        amount={net}
        serviceFeeVal={feeService}
        alpha2={currency && currency.countryAlpha2}
        prefix={currency && currency.prefix}
        tax={finalTax}
        totalPayable={totalPayable}
        discount={discount}
        subTotal={subTotal}
      />
      id = name;
    } else if (name === TabNames.GOOGLE_PAY_US) {
      children = <GooglePay
          headerText={"PAY WITH GOOGLE PAY"}
          payment={{amount: totalPayable && totalPayable, currency: account && account.currency}}
          chargeByGooglePay={chargeByGooglePay}
          errorMsg={errorMessage}
          gpaySecretValues={gpaySecretValues}
          gpayError={gpayError}
          errorHeader={null}
      />
      id = name;
  } else if (name === TabNames.WALLET) {
      children = <GooglePay
          headerText={"PAY WITH GOOGLE PAY"}
          payment={{amount: totalPayable && totalPayable, currency: account && account.currency}}
          chargeByGooglePay={chargeByGooglePay}
          gpaySecretValues={gpaySecretValues}
          gpayError={gpayError}
          errorMsg={errorMessage}
          errorHeader={null}
      />
      id = name;
  }else if (name === TabNames.APPLE_PAY_US) {
      children = <ApplePay
          headerText={"PAY WITH APPLE PAY"}
          payment={{amount: totalPayable && totalPayable, currency: currency && currency}}
          chargeByApplePay={chargeByApplePay}
          gpayError={null}
          errorMsg={errorMessage}
          errorHeader={null}
      />
      id = name;
  } else if (name === TabNames.INSTANT_PAYMENT) {
      children = <InstantPayment
        errorHeader={null}
        customerReadOnly={false}
        errorMsg={errorMessage}
        customerFields={{}}
        submit={chargeByInstantPay}
        customerDisabled={true}
        headerText={null}
        buttonText={submitBtnText}
        showCustomer={true}
        customerValidation={true}
        paymentPage={true}
        showWhatsAppNotify={false}
        hideQr={true}
        upiUrl={`${BASE_URLS.PAYMENT_PAGE_LINK}/${id}`}
        tip={finalTip}
        surcharge={surcharge}
        serviceFee={serviceFee}
        serviceFeeRate={serviceFeeRate}
        serviceFeeRateVal={serviceFeeRateVal}
        amount={net}
        serviceFeeVal={feeService}
        alpha2={currency && currency.countryAlpha2}
        prefix={currency && currency.prefix}
        tax={finalTax}
        totalPayable={totalPayable}
        discount={discount}
        subTotal={subTotal}
        setRecaptchaModalVisible={setRecaptchaModalVisible}
        setSavedPaymentDetails={setSavedPaymentDetails}
        savedPaymentDetails={savedPaymentDetails}
        globalRecaptchaToken={paymentLinkInstantPaymentGlobalRecaptcha}
        setGlobalRecaptchaToken={setPaymentLinkInstantPaymentGlobalRecaptcha}
        setRecaptchaPaymentType={setRecaptchaPaymentType}
      />
      id = name;
    } else if (name === TabNames.SWIREPAY_US) {
      children = <InstantPayment
        errorHeader={null}
        customerReadOnly={false}
        errorMsg={errorMessage}
        customerFields={{}}
        submit={chargeBySwirepayUS}
        customerDisabled={true}
        headerText={null}
        buttonText={submitBtnText}
        customerValidation={true}
        showWhatsAppNotify={false}
        getPaymentById={getQrPaymentById}
        hideQr={false}
        upiUrl={`${BASE_URLS.DONATION_PAGE_LINK}/${id}`}
        tip={finalTip}
        surcharge={surcharge}
        serviceFee={serviceFee}
        serviceFeeRate={serviceFeeRate}
        serviceFeeRateVal={serviceFeeRateVal}
        amount={net}
        serviceFeeVal={feeService}
        alpha2={currency && currency.countryAlpha2}
        prefix={currency && currency.prefix}
        paymentMethodDetails={true}
        paymentMethodType={true}
        tax={finalTax}
        totalPayable={totalPayable}
        discount={discount}
        subTotal={subTotal}
        swirepayUS={swirepayUS}
        metaGid={paymentPageMeta.gid}
        metaPageEntries={paymentPageEntries}
        paymentInterval={entries?.interval}
        donationPay={true}
        donationPageEntry={entries}
        setRecaptchaModalVisible={setRecaptchaModalVisible}
        setSavedPaymentDetails={setSavedPaymentDetails}
        savedPaymentDetails={savedPaymentDetails}
        globalRecaptchaToken={paymentLinkInstantPaymentGlobalRecaptcha}
        setGlobalRecaptchaToken={setPaymentLinkInstantPaymentGlobalRecaptcha}
        setRecaptchaPaymentType={setRecaptchaPaymentType}
      />
      id = name;
    } else {
      children = <DescriptionText>Processing payment. Please wait...</DescriptionText>
    }
    panel.push({ children, id });
    return panel;
  }, []) : [{
    children: <CardPayment
      errorMsg={errorMessage}
      errorHeader={null}
      customerReadOnly={false}
      submit={paymentPageChargeCard}
      preFillCustomer={customerDetails}
      customerFields={{}}
      paymentPagePay={false}
      headerText={"Pay With Card"}
      buttonText={submitBtnText}
      isZipCodeRequired={(account && account.collectCustomerAddress)}
      isBillingAdressRequired={(account && account.collectBillingAddress)}
      customerValidation={true}
      showWhatsAppNotify={false}
      tip={finalTip}
      surcharge={surcharge}
      serviceFee={serviceFee}
      serviceFeeRate={serviceFeeRate}
      serviceFeeRateVal={serviceFeeRateVal}
      amount={net}
      serviceFeeVal={feeService}
      alpha2={currency && currency.countryAlpha2}
      prefix={currency && currency.prefix}
      tax={finalTax}
      totalPayable={totalPayable}
      discount={discount}
      subTotal={subTotal}
      payment={{amount: totalPayable && totalPayable, currency: currency && currency}}
      chargeByApplePay={chargeByApplePay}
      ApplePayment={applePayment}
      accountId={account && account.gid}
      getCardNum={getCardNum}
      surchargeType={account?.surchargeType}
      updateSurcharge={updateSurcharge}
      surchargeEnabled={paymentPageMeta?.surchargeEnabled}
    />,
    id: 'CARD'
  }];
  const tabPanelsApple =
                
           {// children :  <Apple amount={totalPayable} accountName={account && account.name} chargeByApple={chargeByApple} payment={paymentPageMeta}/>
              children : applePayment&&isApplePay ? <Apple amount={totalPayable && totalPayable}  accountName={account && account.name} chargeByApple={chargeByApple} payment={paymentPageMeta}/>:null,
              id: applePayment && isApplePay ? 'APPLE_PAY_US' : null
            };

    tabPanels.push(tabPanelsApple);

 /* const tabPanelsApple =
                    
           { //children :  <Apple amount={AmountDivideByHundred(payment && payment.amount)} chargeByApple={chargeByApple} payment={payment}/>
              children : applePayment&&isApplePay ? <Apple amount={totalPayable} chargeByApple={chargeByApple} payment={paymentPageMeta}/>:null  
            }
    ;

    tabPanels.push(tabPanelsApple);*/

  useEffect(() => {
    setTabName(uniquePaymentTypes && uniquePaymentTypes[selectedTab]);
  }, [selectedTab, uniquePaymentTypes]);

  const customContainerProps = {
    // borderWidth: '5px !important',
    // borderColor: '#000 !important',
    // borderStyle: 'solid !important',
    borderRadius: '10px !important',
    width: '100%',
    padding: '5% !important',
    backgroundColor: '#fff',
  };

  const customFlexContainerProps = {
    width: '100%',
  }

  const customPrimaryHeadingProps = {
    fontWeight: 'bold',
    marginTop: '5px',
    marginBottom: '5px',
    fontSize: '20px',
  };

  const customSecondaryHeadingProps = {
    fontWeight: 'bold',
    textTransform: 'none',
    marginRight: '10px',
  }

  const customDescriptionProps = {
    fontSize: '18px',
    whiteSpace: 'wrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };

  return (
    <BaseSplitPage 
    errorHeader={null}
    errorMsg={errorMessage}
    left={
      <>
        <FlexContainer
          flexDirection="column"
          position="relative"
          display="block"
          height="100%"
        >
          <div>
            <LeftBackButtonText
              onClick={() => { props.history.push(`/donation-page-link/${id}`); }}
            >
              Back
            </LeftBackButtonText>
            <H1Text>
              Payment Checkout
            </H1Text>
            <H2Text>
              Payment For
            </H2Text>
            <DescriptionText>
              {paymentPageMeta && paymentPageMeta.title}
            </DescriptionText>
            {/*<H2Text>
              Amount Payable
            </H2Text>
            <DescriptionText fontSize="24px">
            {currency && currency.prefix} {totalPayable ? AmountDivideByHundred(totalPayable) : '0.00'}
            </DescriptionText>*/}
          </div>
          <div style={{ position: "sticky", top: "85%" }}>
            <Support email={paymentPageMeta && paymentPageMeta.contactUsEmail}
              whiteLabel={account && account.whiteLabel}
              phone={paymentPageMeta && paymentPageMeta.contactUsPhone} />
          </div>
        </FlexContainer>
      </>
    } right={
      <>
        <SmallScreenHeader cancelUrlLink={`/donation-page-link/${id}`}>
          <FlexContainer {...customContainerProps}>
            <H1Text>
              Payment Checkout
            </H1Text>
            <Hr/>
            <FlexContainer {...customFlexContainerProps}>
              <H2Text {...customSecondaryHeadingProps}>
                Payment For
              </H2Text>
              <DescriptionText {...customDescriptionProps}>
                {paymentPageMeta && paymentPageMeta.title}
              </DescriptionText>
            </FlexContainer>
          </FlexContainer>
        </SmallScreenHeader>
        <PaymentExpandableRows
          id={id}
          paymentTypes={(account && account.currency && account.currency.countryAlpha2)}
          tabs={uniquePaymentTypes}
          tabPanels={tabPanels}
          defaultSelectedTab={selectedTab || 0}
          onSelect={data => setSelectedTab(data)}
          tabName={tabName}
          upiDown={upiDownTime}
          applePayment={applePayment}
          isApplePay ={isApplePay}
          accountGid={account?.gid}
          getCurrentTab={getCurrentTab}
        />
        <RecaptchaModal
          visible={recaptchaModalVisible}
          onVerified={onGlobalCaptchaVerified}
        />
        <TransactionModal body={null} header={null} isOpen={isTransactionModalOpen} />
        <SuccessModal isOpen={isTransactionSuccessModalOpen} processing={processStatus} />
        <Spinner isOpen={isShowSpinner} />
        {/* <DataAlertModal isOpen={isDataAlertModalOpen} header={"We lost your data"} body={"You will be redirect"} /> */}
      </>
    } />
  )
};

export default DonationPagePay;
